import { SecEventViewModel } from '@threatadvisor/react-utils/src/types/generated.SecurityEvent';
import { GlobalToken } from 'antd/es/theme/interface';
import { CSSProperties } from 'react';

function getColorForSeverityText(severityText: string): CSSProperties['color'] | undefined {
  if (severityText.toLowerCase().includes('critical')) return '#403d3c';
  if (severityText.toLowerCase().includes('high')) return '#f94615';
  if (severityText.toLowerCase().includes('medium')) return '#ffba02';
  if (severityText.toLowerCase().includes('low')) return '#257dd0';
  if (severityText.toLowerCase().includes('informational')) return '#5a8d17';
}

function getNumberForSeverityText(severityText: string): number {
  if (severityText.toLowerCase().includes('critical')) return 5;
  if (severityText.toLowerCase().includes('high')) return 4;
  if (severityText.toLowerCase().includes('medium')) return 3;
  if (severityText.toLowerCase().includes('low')) return 2;
  if (severityText.toLowerCase().includes('informational')) return 1;
  return 0;
}

export function getPriorityScaleColors(): any {
  // colorField; series
  return {
    scale: {
      color: {
        domain: ['P1', 'P2', 'P3', 'P4'],
        range: ['#800020', '#FF5D00', '#ffc104', '#4572c5']
      }
    }
  };
}

export function getPriorityColors(priorty: string): any {
  switch (priorty) {
    case 'P1':
      return '#800020';
    case 'P2':
      return '#FF5D00';
    case 'P3':
      return '#ffc104';
    default:
      // default color, ie P4
      return '#4572c5';
  }
}

const PRIORITY_CONFIG = {
  P1: token => ({ ribbonColor: token.colorError, ribbonText: 'P1' }),
  P2: token => ({ ribbonColor: token.volcano6, ribbonText: 'P2' }),
  P3: token => ({ ribbonColor: token.colorWarning, ribbonText: 'P3' }),
  P4: token => ({ ribbonColor: token.lime6, ribbonText: 'P4' }),
  P5: token => ({ ribbonColor: token.colorPrimary, ribbonText: 'P5' })
};

export const determinePriority = (event: SecEventViewModel, token: GlobalToken) => {
  const priority = event.priority;
  if (!priority || !PRIORITY_CONFIG[priority]) {
    return { ribbonColor: 'purple', ribbonText: 'P?' };
  }
  return PRIORITY_CONFIG[priority](token);
};
